import React, { useEffect, useState } from "react";
import { X, Share2, Download, Loader2 } from "lucide-react";
import { renderReceiptCard, shareReceiptCard, downloadReceiptCard } from "../lib/receiptCard";

// Full-screen preview of the branded payout receipt with one-tap share/save.
export function ReceiptPreview({ record, onClose }) {
  const [img, setImg] = useState(null);
  useEffect(() => { let on = true; renderReceiptCard(record).then((u) => on && setImg(u)); return () => { on = false; }; }, [record]);
  return (
    <div className="fixed inset-0 z-[70] bg-black/80 backdrop-blur-sm flex flex-col items-center justify-center p-4" onClick={onClose} data-testid="receipt-preview">
      <div className="w-full max-w-sm" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between text-white mb-2">
          <span className="font-display font-bold">Payout Receipt · ₹{record.amount}</span>
          <button onClick={onClose} className="w-9 h-9 rounded-full bg-white/15 flex items-center justify-center" aria-label="close" data-testid="receipt-preview-close"><X className="w-5 h-5" /></button>
        </div>
        <div className="rounded-2xl overflow-hidden shadow-2xl bg-slate-900 aspect-[4/5] flex items-center justify-center">
          {img ? <img src={img} alt="Payout receipt" className="w-full h-full object-contain" data-testid="receipt-preview-img" /> : <Loader2 className="w-8 h-8 text-white animate-spin" />}
        </div>
        <div className="flex gap-2 mt-3">
          <button onClick={() => shareReceiptCard(record)} disabled={!img} className="flex-1 py-3 rounded-xl bg-emerald-500 text-white font-bold flex items-center justify-center gap-2 disabled:opacity-50" data-testid="receipt-preview-share"><Share2 className="w-4 h-4" />Share on WhatsApp</button>
          <button onClick={() => downloadReceiptCard(record)} disabled={!img} className="w-14 rounded-xl bg-white text-slate-900 flex items-center justify-center disabled:opacity-50" aria-label="save" data-testid="receipt-preview-download"><Download className="w-5 h-5" /></button>
        </div>
      </div>
    </div>
  );
}
